import Layout from '@/View/CustomerSupport/layout/layout.vue'
export const CustomerSupport = {
  path: '/customerSupport',
  component: Layout,
  hidden: false,
  redirect: '/customerSupport/dashboard',
  name: 'CustomerSupport',
  meta: {
    breadCrumb: 'Customer Support',
    title: 'Customer Support',
    icon: 'dashboard',
    selected: false,
    permission: ''
  },
  children: [{
    path: '/customerSupport/dashboard',
    component: () => import('@/View/CustomerSupport/dashboard/dashboard.vue'),
    name: 'CustomerSupportDashboard',
    meta: {
      breadCrumb: 'Dashboard',
      icon: 'dashboard',
      title: 'Dashboard',
      selected: false,
      permissionList: []
    }
  },
  {// Ticket routing
    path: '/customerSupport/ticket',
    component: () => import('@/View/CustomerSupport/Main/main.vue'),
    hidden: false,
    redirect: '/customerSupport/ticket/list',
    name: 'CustomerSupportTickets',
    meta: {
      breadCrumb: 'Ticket',
      title: 'Tickets',
      icon: 'fas fa-ticket-alt',
      color: 'primary',
      selected: false,
      permissionList: ['ticket__view_all', 'ticket__view_specific']
    },
    children: [{
      path: '/customerSupport/ticket/list',
      component: () => import('@/View/CustomerSupport/Tickets'),
      name: 'CustomerSupportTickets',
      hidden: false,
      meta: {
        breadCrumb: 'List',
        title: 'List'
      }
    },
    {
      path: '/customerSupport/ticket/detail/:ticketingMasterId',
      component: () => import('@/View/CustomerSupport/Tickets/ticketDetails.vue'),
      name: 'ticketDetails',
      meta: {
        breadCrumb: 'details',
        icon: '',
        title: 'Ticket Details',
        selected: false,
        permissionList: []
      }
    }]
  },
  {// Troubleshooting routing
    path: '/customerSupport/troubleshooting',
    component: () => import('@/View/CustomerSupport/Main/main.vue'),
    hidden: false,
    redirect: '/customerSupport/troubleshooting/list',
    name: 'CustomerSupportTroubleshooting',
    meta: {
      breadCrumb: 'troubleshooting',
      title: 'Troubleshooting',
      icon: 'fas fa-headset',
      color: 'primary',
      selected: false,
      permissionList: ['troubleshooting__view_all', 'troubleshooting__view_specific']
    },
    children: [{
      path: '/customerSupport/troubleshooting/list',
      component: () => import('@/View/CustomerSupport/Troubleshooting'),
      name: 'CustomerSupportTroubleshooting',
      hidden: false,
      meta: {
        breadCrumb: 'List',
        title: 'List'
      }
    }]
  },
  {// Setting object start
    path: '/customerSupport/setting',
    component: () => import('@/View/CustomerSupport/Main/main.vue'),
    hidden: false,
    redirect: '/customerSupport/setting/dashboard',
    name: 'CustomerSupportSettings',
    meta: {
      breadCrumb: 'Setting',
      title: 'Settings',
      icon: 'fas fa-cogs',
      color: 'primary',
      selected: false,
      permissionList: ['customer_support_setting__troubleshooting_question__manage', 'customer_support_setting__troubleshooting_topic__manage', 'customer_support_setting__troubleshooting_source__manage', 'customer_support_setting__ticket_status__manage']
    },
    children: [{
      path: '/customerSupport/setting/dashboard',
      component: () => import('@/View/CustomerSupport/Settings/dashboard/dashboard.vue'),
      name: 'CustomerSupportSettings',
      hidden: false,
      meta: {
        breadCrumb: 'Dashboard',
        title: 'Dashboard'
      }
    },
    {
      path: '/customerSupport/setting/troubleshootingTopic',
      component: () => import('@/View/CustomerSupport/Settings/TroubleshootingTopic/topicList.vue'),
      name: 'troubleshootingTopicList',
      hidden: false,
      meta: {
        breadCrumb: 'troubleshootingTopicList',
        icon: 'fas fa-headset',
        color: 'primary',
        title: 'Troubleshooting Topics',
        permissionList: ['customer_support_setting__troubleshooting_topic__manage']
      }
    },
    {
      path: '/customerSupport/setting/addTroubleshootingTopic/:topicId',
      component: () => import('@/View/CustomerSupport/Settings/TroubleshootingTopic/addTopic.vue'),
      name: 'troubleshootingTopicAdd',
      hidden: true,
      meta: {
        breadCrumb: 'troubleshootingTopicAdd',
        icon: 'PS',
        color: 'primary',
        title: 'Troubleshooting Topics Add',
        permissionList: ['customer_support_setting__troubleshooting_topic__manage']
      }
    },
    {
      path: '/customerSupport/setting/troubleshootingTopicDetail/:topicId',
      component: () => import('@/View/CustomerSupport/Settings/TroubleshootingTopic/topicDetail.vue'),
      name: 'troubleshootingTopicDetail',
      hidden: true,
      meta: {
        breadCrumb: 'troubleshootingTopicDetail',
        icon: 'PS',
        color: 'primary',
        title: 'Troubleshooting Topics Detail',
        permissionList: ['customer_support_setting__troubleshooting_topic__manage']
      }
    },
    {
      path: '/customerSupport/setting/troubleshootingQuestions',
      component: () => import('@/View/CustomerSupport/Settings/TroubleshootingQuestion'),
      name: 'troubleshootingQuestion',
      hidden: false,
      meta: {
        breadCrumb: 'troubleshootingQuestion',
        icon: 'fas fa-question-circle',
        color: 'primary',
        title: 'Troubleshooting Question',
        permissionList: ['customer_support_setting__troubleshooting_question__manage']
      }
    },
    {
      path: '/customerSupport/setting/troubleshootingSource',
      component: () => import('@/View/CustomerSupport/Settings/TroubleShootingSource/TroubleShootingSourceList.vue'),
      name: 'troubleshootingSource',
      hidden: false,
      meta: {
        breadCrumb: 'troubleshootingSource',
        icon: 'fab fa-osi',
        color: 'primary',
        title: 'Troubleshooting Source',
        permissionList: ['customer_support_setting__troubleshooting_source__manage']
      }
    },
    {
      path: '/customerSupport/setting/TicketStatus',
      component: () => import('@/View/CustomerSupport/Settings/TicketStatus/ticketstatusList.vue'),
      name: 'ticketstatusList',
      hidden: false,
      meta: {
        breadCrumb: 'ticketstatusList',
        icon: 'fas fa-ticket-alt',
        color: 'primary',
        title: 'Ticket Status',
        permissionList: ['customer_support_setting__ticket_status__manage']
      }
    },
    {
      path: '/customerSupport/setting/troubleshootingQuestionAdd/:questionMasterId',
      component: () => import('@/View/CustomerSupport/Settings/TroubleshootingQuestion/addQuestion.vue'),
      name: 'addTroubleshootingQuestion',
      hidden: true,
      meta: {
        breadCrumb: 'addTroubleshootingQuestion',
        icon: 'TQ',
        color: 'primary',
        title: 'Troubleshooting Question ADD',
        permissionList: ['customer_support_setting__troubleshooting_question__manage']
      }
    },
    {
      path: '/customerSupport/setting/troubleshootingQuestionDetail/:questionMasterId',
      component: () => import('@/View/CustomerSupport/Settings/TroubleshootingQuestion/questionDetail.vue'),
      name: 'troubleshootingQuestionDetail',
      hidden: true,
      meta: {
        breadCrumb: 'troubleshootingQuestionDetail',
        icon: 'TQ',
        color: 'primary',
        title: 'Troubleshooting Question detail',
        permissionList: ['customer_support_setting__troubleshooting_question__manage']
      }
    }]
  }]
}



// WEBPACK FOOTER //
// ./src/View/CustomerSupport/router/index.js